import { isUserLoggedIn } from '@/auth/utils'

export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/modules/auth/login/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/modules/main/Dashboard.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Métricas',
          active: true,
          showOnRoles: ['admin']
        },
        {
          text: 'Dashboard',
          active: true
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/deliveries/create',
    name: 'deliveries-create',
    component: () => import('@/views/modules/deliveries/create/TabsDeliveries.vue'),
    meta: {
      resource: 'deliveries',
      action: 'create',
      breadcrumb: [
        {
          text: 'Envíos',
          active: true
        },
        {
          text: 'Crear envíos',
          active: true
        }
      ]
    }
  },
  {
    path: '/summaries/:id_summary',
    name: 'summary-detail', // Archivo de traducciones
    component: () => import('@/views/modules/summaries/SummaryDetail.vue'),
    meta: {
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/deliveries',
    name: 'deliveries-list',
    component: () => import('@/views/modules/deliveries/list-deliveries/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Envíos',
          active: true
        },
        {
          text: 'Listado de envíos',
          active: true
        }
      ],
      resource: 'deliveries',
      action: 'list'
    }
  },
  // Ruta de prueba de vista
  {
    path: '/deliveries/:id',
    name: 'deliveries-details',
    component: () =>
      import(
        '@/views/modules/deliveries/list-deliveries/detail-delivery/Details.vue'
      ),
    meta: {
      breadcrumb: [
        {
          text: 'Envíos',
          active: true
        },
        {
          text: 'Listado de envíos',
          active: false,
          to: { name: 'deliveries-list' },
          showOnRoles: ['admin', 'seller', 'ecommerce', 'marketplace', 'custom'],
          permissionBreadCrumb: 'canBreadcumbListDeliveries'
        },
        {
          text: 'Listado de envíos',
          active: false,
          to: { name: 'deliveries-pudos' },
          showOnRoles: ['pudo'],
          permissionBreadCrumb: 'canBreadcumbListDeliveriesPudo'
        },
        {
          active: true,
          text: '{id}'
        }
      ],
      resource: 'deliveries',
      action: 'details'
    }
  },
  {
    path: '/return-deliveries-create',
    name: 'returns',
    component: () => import('@/views/modules/returns/create-returns/Tabs.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Devoluciones',
          active: true
        },
        {
          text: 'Crear devolución',
          active: true
        }
      ],
      resource: 'returns',
      action: 'create'
    }
  },
  // PROVITIONAL ROUTE FROM PLATFORM
  {
    path: '/returns/create',
    name: 'returns-create', // El name corresponde al archivo de traducciones
    component: () => import('@/views/modules/returns/create-returns/new-return/Create.vue'),
    meta: {
      resource: 'returns',
      action: 'create'
    }
  },
  {
    path: '/returns/list',
    name: 'returns-list',
    component: () => import('@/views/modules/returns/list-returns/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Devoluciones',
          active: true
        },
        {
          text: 'Listado de devoluciones',
          active: true
        }
      ],
      resource: 'returns',
      action: 'list'
    }
  },
  {
    path: '/return-deliveries/:id',
    name: 'return-details',
    component: () => import('@/views/modules/returns/details/Details.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Devoluciones',
          active: true
        },
        {
          text: 'Listado de devoluciones',
          active: false,
          to: { name: 'returns-list' }
        },
        {
          active: true,
          text: '{id}'
        }
      ],
      resource: 'returns',
      action: 'details'
    }
  },
  {
    path: '/marketcenter',
    name: 'marketcenter',
    component: () => import('@/views/modules/marketcenter/config/Marketcenter.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Marketcenter',
          active: true
        },
        {
          text: 'Canales de venta',
          active: true
        }
      ],
      resource: 'marketcenter',
      action: 'config'
    }
  },
  {
    path: '/marketcenter/:shipper_id/:marketcenter_code/:edit?',
    name: 'marketcenter-detail',
    component: () => import('@/views/modules/marketcenter/config/DetailConfig.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Marketcenter',
          active: true
        },
        {
          text: 'Canales de venta',
          active: true
        },
        {
          text: '{marketcenter_code}',
          active: true
        }
      ],
      resource: 'marketcenter',
      action: 'config'
    }
  },
  {
    path: '/marketcenter-deliveries',
    name: 'marketcenter-deliveries',
    component: () => import('@/views/modules/marketcenter/deliveries/TabDeliveries.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Marketcenter',
          active: true
        },
        {
          text: 'Listado de envíos',
          active: true
        }
      ],
      resource: 'marketcenter',
      action: 'deliveries'
    }
  },
  {
    path: '/marketcenter-products',
    name: 'marketcenter-products',
    component: () => import('@/views/modules/marketcenter/products/ListProducts.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Marketcenter',
          active: true
        },
        {
          text: 'Listado de productos',
          active: true
        }
      ],
      resource: 'marketcenter',
      action: 'products'
    }
  },
  {
    path: '/admin-pickups',
    name: 'pickups',
    component: () =>
      import('@/views/modules/pickups/admin-pickups/Pickups.vue'),
    meta: {
      breadcrumb: [{
        text: 'Retiros',
        active: true
      }],
      resource: 'pickups',
      action: 'admin'
    }
  },
  // Vista publica cancelación de retiros
  {
    path: '/public/pickups/:uuid/cancel',
    name: 'pickups-cancel',
    component: () =>
      import('@/views/modules/pickups/public-views/CancelPickups.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  // Vista publica evaluación de retiros
  {
    path: '/public/pickups/:uuid/evaluate',
    name: 'pickups-evaluate',
    component: () =>
      import('@/views/modules/pickups/public-views/EvaluatePickups.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  // Vista publica confirmar retiro frecuente
  {
    path: '/public/pickups/:uuid/confirm-frequent',
    name: 'pickups',
    component: () =>
      import('@/views/modules/pickups/public-views/ConfirmFrequentPickup.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  // Bloqueo creacion de retiros para empresas
  {
    path: '/pickups/configs/disable-companies',
    name: 'disable-companies',
    component: () =>
      import('@/views/modules/pickups-config/disable-pickups/List.vue'),
    meta: {
      breadcrumb: [{
        text: 'Desactivación de empresas',
        active: true
      }],
      // layout: 'full',
      resource: 'deliveries',
      action: 'list'
    }
  },
  {
    path: '/tracking',
    name: 'config-tracking',
    component: () =>
      import('@/views/modules/configuration/tracking/Tabs.vue'),
    meta: {
      breadcrumb: [{
        text: 'Configuraciones',
        active: true
      },
      {
        text: 'Tracking',
        active: true
      }
      ],
      resource: 'config',
      action: 'tracking'
    }
  },
  {
    path: '/communications',
    name: 'config-communications',
    component: () =>
      import('@/views/modules/configuration/communications/Communications.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Comunicados',
          active: true
        }
      ],
      resource: 'config',
      action: 'notifications'
    }
  },
  {
    path: '/carriers',
    name: 'config-carriers',
    component: () => import('@/views/modules/configuration/carriers/Carriers.vue'),
    meta: {
      breadcrumb: [{
        icon: 'SettingsIcon',
        active: true
      },
      {
        text: 'Couriers',
        active: true
      }
      ],
      resource: 'config',
      action: 'carriers'
    }
  },
  {
    path: '/carriers-platforms',
    name: 'config-carriers-platforms',
    component: () => import('@/views/modules/configuration/carriers/Carriers.vue'),
    meta: {
      breadcrumb: [{
        text: 'Couriers',
        active: true
      },
      {
        text: 'Listado de couriers',
        active: true
      }
      ],
      resource: 'carriers',
      action: 'mantenedor'
    }
  },
  {
    path: '/carriers-platforms/details/:id/:name/:code',
    name: 'details-carriers-platforms',
    component: () =>
      import('@/views/modules/configuration/carriers/details/DetailsPlatform.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Couriers',
          active: true
        },
        {
          text: 'Listado de couriers',
          active: false,
          to: { name: 'config-carriers-platforms' }
        },
        {
          active: true,
          text: '{id}'
        }
      ],
      resource: 'carriers',
      action: 'mantenedor'
    }
  },
  {
    path: '/carriers/create',
    name: 'create-carriers',
    component: () =>
      import('@/views/modules/configuration/carriers/generals/Generals.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Couriers',
          active: true
        },
        {
          text: 'Listado de couriers',
          active: false,
          to: { name: 'config-carriers-platforms' }
        },
        {
          active: true,
          text: 'Crear Courier'
        }
      ],
      resource: 'carriers',
      action: 'mantenedor'
    }
  },
  {
    path: '/advanced-rules/:entity/:entity_id/:rule_id',
    name: 'advanced-rules-create',
    component: () =>
      import('@/views/modules/advanced-rules/create/Rule.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas',
          active: false,
          to: { name: 'advanced-rules-list' }
        },
        {
          text: 'Configurar regla',
          active: true
        }
      ],
      resource: 'advanced-rules',
      action: 'create'
    }
  },
  {
    path: '/advanced-rules',
    name: 'advanced-rules-list',
    component: () =>
      import('@/views/modules/advanced-rules/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas',
          active: true
        }
      ],
      resource: 'advanced-rules',
      action: 'list'
    }
  },
  {
    path: '/create-group',
    name: 'tm-group-create',
    component: () =>
      import('@/views/modules/tickets-management/groups/create/CreateGroup.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas tickets',
          active: true
        },
        {
          text: 'Crear grupo',
          active: true
        }
      ],
      resource: 'rule-tickets',
      action: 'create-group'
    }
  },
  {
    path: '/groups',
    name: 'tm-group-list',
    component: () =>
      import('@/views/modules/tickets-management/groups/list/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas tickets',
          active: true
        },
        {
          text: 'Grupos',
          active: true
        }
      ],
      resource: 'rule-tickets',
      action: 'groups'
    }
  },
  {
    path: '/list-rules',
    name: 'tm-rule-list',
    component: () =>
      import('@/views/modules/tickets-management/rules/list/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas tickets',
          active: true
        },
        {
          text: 'Reglas de tickets',
          active: true
        }
      ],
      resource: 'rule-tickets',
      action: 'list'
    }
  },
  {
    path: '/create-rule',
    name: 'tm-rule-create',
    component: () =>
      import('@/views/modules/tickets-management/rules/create/CreateRule.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reglas tickets',
          active: true
        },
        {
          text: 'Crear regla',
          active: true
        }
      ],
      resource: 'rule-tickets',
      action: 'create'
    }
  },
  {
    path: '/detail-ticket-rules/:id',
    name: 'tm-rule-modify',
    component: () =>
      import('@/views/modules/tickets-management/rules/create/ModifyRule.vue'),
    meta: {
      breadcrumb: [{
        icon: 'ClipboardIcon',
        active: true
      },
      {
        text: 'Listado de reglas',
        active: false,
        to: { name: 'ticket-rules' }
      },
      {
        text: 'Modificar regla',
        active: true
      }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/tickets-pending',
    name: 'tickets-pending',
    component: () => import('@/views/modules/tickets-pending/List.vue'),
    meta: {
      filter: {
        current_status: 'ISSUE_INFO_REQUESTED,COMPLAINT_INFO_REQUESTED,COMPENSATION_INFO_REQUESTED,ISSUE_DOC_REQUESTED,COMPLAINT_DOC_REQUESTED,COMPENSATION_DOC_REQUESTED,DISAGREEMENT_INFO_REQUESTED,DISAGREEMENT_DOC_REQUESTED',
        waiting_days: true,
        order_by: 'WAITING_DAYS_DESC'
      },
      breadcrumb: [
        {
          text: 'Tickets',
          active: true
        },
        {
          text: 'Mis gestiones pendientes',
          active: true
        }
      ],
      resource: 'tickets',
      action: 'pending'
    }
  },
  // {
  //   path: '/cyber-form',
  //   name: 'cyber-form',
  //   component: () => import('@/views/modules/cyber-form/CyberForm.vue'),
  //   meta: {
  //     filter: {},
  //     breadcrumb: [
  //       {
  //         text: 'Formulario Cyber-day',
  //         active: true
  //       }
  //     ],
  //     // layout: 'full',
  //     action: 'dashboard',
  //     resource: 'menu',
  //     shipperCountry: ['CL'],
  //     organizationCountry: ['CL'],
  //     organizationIdHidden: [1162, 7551] // 1162 Cenco Mkp, 7551 Walmart Mkp
  //   }
  // },
  {
    path: '/default-answer',
    name: 'default-answer',
    component: () => import('@/views/modules/default-answer/List.vue'),
    meta: {
      filter: {},
      breadcrumb: [
        {
          text: 'Configuraciones',
          active: true
        },
        {
          text: 'Respuestas predeterminadas',
          active: true
        }
      ],
      resource: 'config',
      action: 'default-answer'
    }
  },
  {
    path: '/report-problem/:token',
    name: 'report-problem',
    component: () => import('@/views/modules/report-problem/ReportProblem.vue'),
    meta: {
      filter: {},
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/support',
    name: 'support',
    component: () =>
      import('@/views/modules/support/Main.vue'),
    meta: {
      breadcrumb: [{
        text: 'Soporte y ayuda',
        active: true
      }],
      resource: 'support',
      action: 'info'
    }
  },
  {
    path: '/support/carriers',
    name: 'support-carriers',
    component: () =>
      import('@/views/modules/support/Carriers.vue'),
    meta: {
      breadcrumb: [{
        text: 'Soporte y ayuda',
        to: '/support'
      },
      {
        text: 'Couriers',
        active: true
      }
      ],
      resource: 'support',
      action: 'carriers'
    }
  },
  {
    path: '/recovery',
    name: 'recovery',
    component: () =>
      import('@/views/modules/auth/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/signup',
    name: 'signup',
    component: () =>
      import('@/views/modules/auth/Signup.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () =>
      import('@/views/modules/auth/profile/Profile.vue'),
    meta: {
      resource: 'common',
      action: 'manage',
      redirectIfLoggedIn: false
    }
  },

  {
    path: '/403',
    name: 'forbidden',
    component: () =>
      import('@/views/modules/others/error.vue'),
    meta: {
      resource: 'common',
      action: 'manage',
      error: {
        code: 403,
        title: 'error-forbidden',
        subtitle: 'error-msg-forbidden'
      }
    }
  },
  {
    path: '/404',
    name: 'error',
    component: () =>
      import('@/views/modules/others/error.vue'),
    meta: {
      resource: 'menu',
      action: 'dashboard',
      error: {
        code: 404,
        title: 'error-not-found',
        subtitle: 'error-msg-not-found'
      }
    }
  },
  {
    path: '/external-login',
    name: 'external-login',
    component: () =>
      import('@/views/modules/auth/ExternalLogin.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
      noRedirect: true
    }
  },
  {
    path: '/tienda-nube/auth',
    name: 'tienda-nube',
    component: () =>
      import('@/views/modules/auth/TiendanubeAuth.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tiendanube',
          active: true
        },
        {
          text: 'Autorización',
          active: true
        }
      ],
      resource: 'Auth'
    },
    beforeEnter: (to, from, next) => {
      const isLoggedIn = isUserLoggedIn()
      const whitelist_login = ['/tienda-nube/auth']
      if (!whitelist_login.includes(to.path)) {
        next('/404')
      } else if (!isLoggedIn) {
        const queryParams = to.query
        const baseUrl = to.path
        const redirectUrl = Object.keys(queryParams).length > 0 ? `${baseUrl}?${new URLSearchParams(queryParams).toString()}` : baseUrl
        next({
          path: '/login',
          query: { redirect_url: redirectUrl }
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/multivende/auth',
    name: 'multivende',
    component: () =>
      import('@/views/modules/auth/MultivendeAuth.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Multivende',
          active: true
        },
        {
          text: 'Autorización',
          active: true
        }
      ],
      resource: 'Auth'
    },
    beforeEnter: (to, from, next) => {
      const isLoggedIn = isUserLoggedIn()
      const whitelist_login = ['/multivende/auth']
      if (!whitelist_login.includes(to.path)) {
        next('/404')
      } else if (!isLoggedIn) {
        const queryParams = to.query
        const baseUrl = to.path
        const redirectUrl = Object.keys(queryParams).length > 0 ? `${baseUrl}?${new URLSearchParams(queryParams).toString()}` : baseUrl
        next({
          path: '/login',
          query: { redirect_url: redirectUrl }
        })
      } else {
        next()
      }
    }
  },
  {
    path: '/external/:token?/:module?/:param1?/:param2?/:param3?',
    name: 'external',
    component: () =>
      import('@/views/modules/auth/External.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/manage-billing-data',
    name: 'billing-manage',
    component: () =>
      import('@/views/modules/billing/manage/ManageContacts.vue'),
    meta: {
      breadcrumb: [{
        text: 'Facturación',
        active: true
      }],
      resource: 'billing',
      action: 'companies'
    }
  },
  {
    path: '/manage-billing-data/:id',
    name: 'manage-edit',
    component: () =>
      import('@/views/modules/billing/manage/edit-create-manage-contacts/CreateManageContacts.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Facturación',
          active: false,
          to: { name: 'billing-manage' }
        },
        {
          active: true,
          text: 'Compañía {id}'
        }
      ],
      resource: 'billing',
      action: 'companies'
    }
  },
  {
    path: '/manage-billing-data/:id/history',
    name: 'manage-edit-history',
    component: () =>
      import('@/views/modules/billing/manage/edit-manage-contacts-history/EditHistoryList.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Facturación',
          active: false,
          to: { name: 'billing-manage' }
        },
        {
          active: true,
          text: 'Compañía {id}'
        },
        {
          active: true,
          text: 'Historial de cambios',
          beta: true
        }
      ],
      resource: 'billing',
      action: 'companies'
    }
  },
  {
    path: '/billing/manage/control',
    name: 'manage-billing-control',
    component: () => import('@/views/modules/billing/manage/control/List.vue'),
    meta: {
      breadcrumb: [{
        text: 'Facturación',
        active: false,
        to: { name: 'billing-manage' }
      },
      {
        text: 'Control de facturación',
        active: true
      }
      ],
      resource: 'billing',
      action: 'companies'
    }
  },
  {
    path: '/manage-billing-data-create',
    name: 'billing-create',
    component: () =>
      import('@/views/modules/billing/manage/edit-create-manage-contacts/CreateManageContacts.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Facturación',
          active: false,
          to: { name: 'billing-manage' }
        },
        {
          active: true,
          text: 'Crear manejador de contactos'
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/billing/:id',
    name: 'billing-details',
    component: () =>
      import('@/views/modules/billing/list-billing-data/Tabs.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Facturación',
          active: true,
          showOnRoles: ['marketplace', 'seller', 'ecommerce']
        },
        {
          text: 'Facturación',
          active: false,
          to: { name: 'billing-manage' },
          showOnRoles: ['admin']
        },
        {
          text: 'Detalles de facturación',
          active: true
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/recaudos/:id',
    name: 'recaudos',
    component: () => import('@/views/modules/billing/list-billing-data/collections/CollectionsForPlatform.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Recaudos',
          active: true
        }
      ],
      resource: 'recaudos',
      action: 'list'
    }
  },
  {
    path: '/billing/manage/:id/logs-indemnifications',
    name: 'historial-ajustes',
    component: () =>
      import('@/views/modules/billing/list-billing-data/indemnifications/HistoryLogAjust.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Detalles de facturacion',
          active: true
        },
        {
          active: false,
          text: 'Indemnizaciones',
          to: { name: 'billing-details' }
        },
        {
          active: true,
          text: 'Historial de ajustes',
          beta: true
        }
      ],
      layout: 'full',
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/couriers/:id',
    name: 'carrier-client',
    component: () =>
      import('@/views/modules/carriers-client/CarriersClient.vue'),
    meta: {
      breadcrumb: [{
        text: 'Couriers',
        active: true
      }],
      resource: 'carriers',
      action: 'carrier-client'
    }
  },
  {
    path: '/materials',
    name: 'materials',
    component: () => import('@/views/modules/materials/Materials.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Solicitud de materiales',
          active: true
        }
      ],
      resource: 'materials',
      action: 'list'
    }
  },
  {
    path: '/tariff-calculator',
    name: 'tariff-calculator',
    component: () => import('@/views/modules/pricing/tariff-calculator/tariffCalculator.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tarificador',
          active: true
        },
        {
          text: 'Tarifas y Cotizador',
          active: true
        }
      ],
      resource: 'pricing',
      action: 'calculator'
    }
  },
  {
    path: '/manage-tariffs',
    name: 'manage-tariffs',
    component: () => import('@/views/modules/pricing/manage-tariffs/ManageTariff.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tarificador',
          active: true
        },
        {
          text: 'Administrar Tarifas',
          active: true
        }
      ],
      resource: 'pricing',
      action: 'manage-tariffs'
    }
  },
  {
    path: '/custom-tariff',
    name: 'custom-tariff',
    component: () => import('@/views/modules/pricing/custom-tariff/CustomTariff.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tarifas Clientes',
          active: true
        }
      ],
      resource: 'pricing',
      action: 'manage-tariffs'
    }
  },
  {
    path: '/config-carriers',
    name: 'list-carriers',
    component: () => import('@/views/modules/configuration/carriers-config/List.vue'),
    meta: {
      breadcrumb: [{
        text: 'Couriers',
        active: true
      },
      {
        text: 'Configuración',
        active: true
      }
      ],
      resource: 'carriers',
      action: 'config'
    }
  },
  {
    path: '/config-carriers/:id_carrier',
    name: 'carrier-detail',
    component: () => import('@/views/modules/configuration/carriers-config/component/DetailCarrier.vue'),
    meta: {
      filter: {},
      breadcrumb: [
        {
          text: 'Configuración',
          to: { name: 'list-carriers' }
        },
        {
          text: '{id_carrier}',
          active: true
        }
      ],
      resource: 'carriers',
      action: 'config-detail'
    }
  },
  {
    path: '/ticket-assignments',
    name: 'assign-user',
    component: () => import('@/views/modules/tickets-assign/AssignTicket.vue'),
    meta: {
      filter: {},
      resource: 'tickets',
      action: 'assignments'
    }
  },
  {
    path: '/priority-config',
    name: 'priority-config',
    component: () => import('@/views/modules/priority-config/List.vue'),
    meta: {
      filter: {},
      breadcrumb: [
        {
          text: 'Matriz de priorización',
          active: true
        }
      ],
      resource: 'config',
      action: 'priority'
    }
  },
  {
    path: '/automatic-reports',
    name: 'automatic-reports',
    component: () => import('@/views/modules/automatic-reports/Reports.vue'),
    meta: {
      resource: 'automatic-reports',
      action: 'list',
      breadcrumb: [
        {
          text: 'Métricas',
          active: true,
          showOnRoles: ['admin']
        },
        {
          text: 'Reportes',
          active: true
        }
      ]
    }
  },
  {
    path: '/automatic-reports/create',
    name: 'automatic-reports-create',
    component: () => import('@/views/modules/automatic-reports/CreateReport.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reportes',
          active: false,
          icon: 'BarChart2Icon',
          to: { name: 'automatic-reports' }
        },
        {
          active: true,
          text: 'Programación de reporte'
        }
      ],
      resource: 'automatic-reports',
      action: 'list'
    }
  },
  {
    path: '/automatic-reports/update/:id',
    name: 'automatic-reports-update', // El name corresponde al archivo de traducciones
    component: () => import('@/views/modules/automatic-reports/CreateReport.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Reportes',
          active: false,
          to: { name: 'automatic-reports' }
        },
        {
          active: true,
          text: 'Edición de reporte'
        }
      ],
      resource: 'automatic-reports',
      action: 'list'
    }
  },
  {
    path: '/pricing-web',
    name: 'pricing-web',
    component: () =>
      import('@/views/modules/pricing/pricing-web/PricingWeb.vue'),
    meta: {
      external: true,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/companies',
    name: 'companies',
    component: () => import('@/views/modules/companies/companies-list/Companies.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Empresas',
          active: true
        }
      ],
      resource: 'companies',
      action: 'list'
    }
  },
  {
    path: '/companies/:id',
    name: 'company-details',
    component: () => import('@/views/modules/companies/companies-id/mainTabs.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Mi empresa',
          active: true,
          showOnRoles: ['ecommerce', 'seller']
        },
        {
          text: 'Empresas',
          active: false,
          to: { name: 'companies' },
          showOnRoles: ['admin', 'marketplace']
        },
        {
          text: '{id}',
          active: true,
          showOnRoles: ['admin', 'marketplace']
        }
      ],
      resource: 'companies',
      action: 'details'
    }
  },
  {
    path: '/modal-new-dev',
    name: 'modal-new-dev',
    component: () => import('@/views/modules/newDevModals/DevModal.vue'),
    meta: {
      filter: {},
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/envia-flash/create',
    name: 'envia-flash', // El name corresponde al archivo de traducciones
    component: () => import('@/views/modules/envia-flash/create/create.vue'),
    meta: {
      breadcrumb: [
        {
          text: ' Envía-Flash',
          active: true,
          to: { name: 'envia-flash' }
        },
        {
          text: ' Crear envíos',
          active: true,
          to: { name: 'envia-flash' }
        }
      ],
      resource: 'envia-flash',
      action: 'create'
    }
  },
  {
    path: '/envia-flash/configuration',
    name: 'envia-flash-config', // El name corresponde al archivo de traducciones
    component: () => import('@/views/modules/envia-flash/config/Configuration.vue'),
    meta: {
      breadcrumb: [
        {
          text: ' Envía-Flash',
          active: true,
          to: { name: 'envia-flash' }
        },
        {
          text: ' Configuración',
          active: true,
          to: { name: 'envia-flash' }
        }
      ],
      resource: 'envia-flash',
      action: 'config'
    }
  },
  {
    path: '/shipments-carriers',
    name: 'shipments-carriers',
    component: () => import('@/views/modules/shipments-carriers/List.vue'),
    meta: {
      filter: {},
      layout: 'carrier',
      action: 'shipments-carriers',
      resource: 'menu'
    }
  },
  {
    path: '/request-carriers',
    name: 'request-carriers',
    component: () => import('@/views/modules/request-carriers/List.vue'),
    meta: {
      filter: {},
      layout: 'carrier',
      action: 'request-carriers',
      resource: 'menu'
    }
  },
  {
    path: '/store-management/:id?',
    name: 'store-management',
    component: () => import('@/views/modules/store-management/StoreManagement'),
    meta: {
      layout: 'full',
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/pudos',
    name: 'pudos',
    component: () => import('@/views/modules/pudos/Pudos.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Puntos de retiro',
          active: true
        }
      ],
      resource: 'pudos',
      action: 'list'
    }
  },
  {
    path: '/deliveries-pudos',
    name: 'deliveries-pudos',
    component: () => import('@/views/modules/pudos/Pudos.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Puntos de retiro',
          active: true
        }
      ],
      resource: 'pudos',
      action: 'list-deliveries'
    }
  },
  {
    path: '/pudos/:id',
    name: 'pudos-edit',
    component: () =>
      import('@/views/modules/pudos/details-pudo/DetailsPudo.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Puntos de retiro',
          active: false,
          to: { name: 'pudos' }
        },
        {
          active: true,
          text: '{id}'
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/tickets',
    name: 'tickets-madagascar',
    component: () =>
      import('@/views/modules/tickets/List.vue'),
    meta: {
      resource: 'tickets',
      action: 'detail',
      breadcrumb: [
        {
          text: 'Tickets',
          active: true
        },
        {
          text: 'Panel',
          active: true
        }
      ]
    }
  },
  {
    path: '/tickets/:id',
    name: 'tickets-madagascar-detail',
    component: () =>
      import('@/views/modules/tickets/components/Detail/DetailTicket.vue'),
    meta: {
      resource: 'tickets',
      action: 'detail'
    }
  },
  {
    path: '/tickets-manifest',
    name: 'tickets-manifest',
    component: () =>
      import('@/views/modules/manifest/List.vue'),
    meta: {
      resource: 'tickets',
      action: 'detail'
    }
  },
  {
    path: '/summaries/:id/logs',
    name: 'tickets-manifest',
    component: () =>
      import('@/views/modules/manifest/components/SumaryLogsTable.vue'),
    meta: {
      resource: 'tickets',
      action: 'detail'
    }
  },
  {
    path: '/prove-rules',
    name: 'prove-rules',
    component: () =>
      import('@/views/modules/prove-rules/ProveRules.vue'),
    meta: {
      layout: 'full',
      resource: 'menu',
      action: 'dashboard'
    }
  }, {
    path: '/team',
    name: 'team',
    component: () =>
      import('@/views/modules/team/Team.vue'),
    meta: {
      resource: 'menu',
      action: 'team-view'
    }
  },
  {
    path: '/restore-password/:user?/:param1?/:param2?',
    name: 'restore-password',
    component: () =>
      import('@/views/modules/auth/RestorePassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/custom-login',
    name: 'custom-login',
    component: () => import('@/views/modules/main/Dashboard.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Pruebas de logueo',
          active: true
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/login-meli',
    name: 'auth-login-meli',
    component: () => import('@/views/modules/auth/LoginMeli.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/form-meli/:param1?',
    name: 'form-meli',
    component: () => import('@/views/modules/auth/FormMeli.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false

    }
  },
  {
    path: '/companies-freemium/:id',
    name: 'edit-companies-freemium',
    component: () => import('@/views/modules/companies/companies-id/CompanyInfo/CompanyInfoFreemium.vue'),
    meta: {
      resource: 'companies',
      action: 'details-freemium',
      breadcrumb: [{
        text: 'Mi empresa',
        active: true
      }]
    }
  },
  {
    path: '/support-freemium',
    name: 'support-freemium',
    component: () =>
      import('@/views/modules/support/MainFreemium.vue'),
    meta: {
      breadcrumb: [{
        text: 'Soporte y ayuda',
        active: true
      }],
      resource: 'companies',
      action: 'details-freemium'
    }
  },
  {
    path: '/auth-token/:param1?/:param2?',
    name: 'auth-token',
    component: () =>
      import('@/views/modules/auth/AuthToken.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth'
    }
  },
  {
    path: '/surveys/pop-up/:token?/:module?/:param1?/:param2?/:param3?/:param4?/:param5?',
    name: 'surveys-pop-up',
    component: () => import('@/views/modules/configuration/communications/modules/components/PopUpSurvey.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false
    }
  },
  {
    path: '/couriers-catalog',
    name: 'couriers-catalog',
    component: () => import('@/views/modules/carriers/CouriersCatalog.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Couriers',
          active: true
        },
        {
          text: 'Catálogo de couriers',
          active: true
        }
      ],
      resource: 'carriers',
      action: 'carrier-client'
    }
  },
  {
    path: '/couriers-catalog/country/:country_id/courier/:courier_name/:courier_id/services/:services',
    name: 'details-couriers-catalog',
    component: () => import('@/views/modules/carriers/components/DetailsCouriersCatalog.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Couriers',
          active: true
        },
        {
          text: 'Catálogo de couriers',
          active: true
        },
        {
          text: '{courier_name}',
          active: true
        }
      ],
      resource: 'carriers',
      action: 'carrier-client'
    }
  },
  {
    path: '/couriers-comparator',
    name: 'catalog-comparator',
    component: () => import('@/views/modules/carriers/components/CouriersComparator.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Couriers',
          active: true
        },
        {
          text: 'Catálogo de couriers',
          active: true
        }
      ],
      resource: 'carriers',
      action: 'carrier-client'
    }
  },
  {
    path: '/auditor-connect',
    name: 'auditor-connect',
    component: () => import('@/views/modules/billing/auditor-connect/AuditorConnect.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Auditor Connect',
          active: true
        }
      ],
      resource: 'billing',
      action: 'connect'
    }
  },
  {
    path: '/complementary-products',
    name: 'complementary-products',
    component: () =>
      import('@/views/modules/complementary-products/ComplementaryProducts.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Productos complementarios',
          active: true
        }
      ],
      resource: 'menu',
      action: 'complementary-products'
    }
  },
  {
    path: '/information-change-address',
    name: 'information-change-address',
    component: () => import('@/views/modules/info-whatsApp/view.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: false,
      noRedirect: true
    }
  },
  {
    path: '/company-shipping-protection',
    name: 'shipping-protection',
    component: () =>
      import('@/views/modules/shipping-protection/shippingProtection.vue'),
    meta: {
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/dashboards-list',
    name: 'dashboards-list',
    component: () =>
      import('@/views/modules/dashboards-list/List.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Métricas',
          active: true
        },
        {
          text: 'Portfolio',
          active: true
        }
      ],
      resource: 'menu',
      action: 'dashboard'
    }
  },
  {
    path: '/eva-agent',
    name: 'eva-agent',
    component: () =>
      import('@/views/modules/carriers/eva-agent/EvaAgent.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Asesor inteligente',
          active: true
        }
      ],
      resource: 'carriers',
      action: 'eva-agent'
    }
  }
]
